module.exports = __webpack_public_path__ + "img/speaker_1.76bb27c1.png";